import { render, staticRenderFns } from "./jydc.vue?vue&type=template&id=cfb15296&scoped=true"
import script from "./jydc.vue?vue&type=script&lang=js"
export * from "./jydc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb15296",
  null
  
)

export default component.exports